import { CreateControllerFn } from '@wix/yoshi-flow-editor';
import { createRecentPostsWidgetController } from '../../recent-posts-widget/controllers/createRecentPostsWidgetController';

const createController: CreateControllerFn = async ({ controllerConfig, flowAPI }) => {
  return createRecentPostsWidgetController(controllerConfig, flowAPI);
};

export default createController;
